import { render, staticRenderFns } from "./group-method.vue?vue&type=template&id=4fc55be0&"
import script from "./group-method.vue?vue&type=script&lang=js&"
export * from "./group-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports